export const API_URL = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');